import { StringType } from '@hb/map-convert';
import { convertPointsString, convertPointString } from '../../utils/transform';
/**
 * 入参转换
 */
export var queryType = {
    /**
     * 坐标对见用“| ”分隔；经度和纬度用","分隔
     */
    origins: StringType(convertPointsString),
    /**
     * 规则： lon，lat（经度，纬度）， “,”分割
     * 如117.500244, 40.417801     经纬度小数点不超过6位
     */
    destination: StringType(convertPointString),
    /**
     * @default 1
     */
    disType: StringType('type'),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2FtYXAvZGlzdGFuY2VNYXRyaXgvY29udmVydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFHN0MsT0FBTyxFQUFFLG1CQUFtQixFQUFFLGtCQUFrQixFQUFFLE1BQU0sdUJBQXVCLENBQUM7QUFFaEY7O0dBRUc7QUFDSCxNQUFNLENBQUMsSUFBTSxTQUFTLEdBQWdCO0lBQ3BDOztPQUVHO0lBQ0gsT0FBTyxFQUFFLFVBQVUsQ0FBQyxtQkFBbUIsQ0FBQztJQUN4Qzs7O09BR0c7SUFDSCxXQUFXLEVBQUUsVUFBVSxDQUFDLGtCQUFrQixDQUFDO0lBQzNDOztPQUVHO0lBQ0gsT0FBTyxFQUFFLFVBQVUsQ0FBQyxNQUFNLENBQUM7Q0FDNUIsQ0FBQyJ9